import {
  GET_MATCH_CARD_LEAGUE_EVENTS_REQUEST,
  GET_MATCH_CARD_LEAGUE_EVENTS_SUCCESS,
  GET_MATCH_CARD_LEAGUE_EVENTS_FAILURE,
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MATCH_CARD_LEAGUE_EVENTS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_MATCH_CARD_LEAGUE_EVENTS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_MATCH_CARD_LEAGUE_EVENTS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
